if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        const optionValueIds = [];
        const wrappers = Array.from(this.querySelectorAll('.product-form__input'));
        for (const wrap of wrappers) {
          const familyInput = wrap.querySelector('input[name="family_wood"], input[name="family_chairtype"], select[name="family_wood"], select[name="family_chairtype"]');
          if (familyInput) continue;
          const selectEl = wrap.querySelector('select');
          if (selectEl && selectEl.selectedOptions && selectEl.selectedOptions.length) {
            const optionValueId = selectEl.selectedOptions[0].dataset.optionValueId;
            if (optionValueId) optionValueIds.push(optionValueId);
            continue;
          }
          const checkedRadio = wrap.querySelector('input[type="radio"]:checked');
          if (checkedRadio && checkedRadio.dataset.optionValueId) {
            optionValueIds.push(checkedRadio.dataset.optionValueId);
          }
        }
        return optionValueIds;
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event, target);
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });
      }

      updateSelectedSwatchValue(event, target) {
        const selectEl = event.target && event.target.tagName === 'SELECT' ? event.target : null;
        const isFamilySelect = selectEl && (selectEl.name === 'family_wood' || selectEl.name === 'family_chairtype');
        if (isFamilySelect && selectEl.selectedOptions.length) {
          const wrapper = selectEl.closest('.product-form__input');
          if (wrapper) {
            const selectedFamilyValue = wrapper.querySelector('[data-selected-family-value]');
            if (selectedFamilyValue) selectedFamilyValue.textContent = selectEl.value;
          }
          return;
        }

        const { value, tagName } = target;

        if (selectEl && selectEl.selectedOptions && selectEl.selectedOptions.length) {
          const optWithSelected = Array.from(selectEl.options).find((option) => option.getAttribute('selected'));
          if (optWithSelected) optWithSelected.removeAttribute('selected');
          selectEl.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = selectEl.selectedOptions[0].dataset.optionSwatchValue;
          const wrapper = selectEl.closest('.product-form__input');
          const selectedDropdownSwatchValue = wrapper && wrapper.querySelector('[data-selected-value] > .swatch');
          if (selectedDropdownSwatchValue) {
            if (swatchValue) {
              selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
              selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
            } else {
              selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
              selectedDropdownSwatchValue.classList.add('swatch--unavailable');
            }
            selectedDropdownSwatchValue.style.setProperty(
              '--swatch-focal-point',
              selectEl.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
            );
          }
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const fieldset = target.closest('.product-form__input');
          if (fieldset) {
            const selectedSwatchValue = fieldset.querySelector('[data-selected-value]');
            if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
            const selectedFamilyValue = fieldset.querySelector('[data-selected-family-value]');
            if (selectedFamilyValue) selectedFamilyValue.textContent = value;
          }
        }
      }
    }
  );
}
